// React & Vendor Libs
import React from 'react';
import ReactDOM from 'react-dom';

// Gallery Custom Links
import Settings from '@app/components/Settings';

document.addEventListener('DOMContentLoaded', function(event) {

	// Gallery Custom Links Settings
	const container = document.getElementById('mgcl-admin-settings');
	if (container) {
		ReactDOM.render((<Settings />), container);
	}

});
